"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetModel = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class AssetModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.placesSelectedByTag = false;
        this.placesSelectedByParent = false;
        this.placeTags = [];
        this.places = [];
        super.init(o);
        this.sensor = o === null || o === void 0 ? void 0 : o.sensor;
        // if (o?.place) {
        // 	if (this.places) {
        // 		this.places.push(o.place)
        // 	} else {
        // 		this.places = [o.place]
        // 	}
        // }
    }
    get __typename() {
        return 'Asset';
    }
    set __typename(v) {
    }
}
exports.AssetModel = AssetModel;
AssetModel.ALL_FIELDS = `id, title,
		assetType,
		sensor,
		manufacturer,
		description,
		model,
		createdDate,
		serialNo,
		lastServiceDate,
		placesSelectedByTag,
		placesSelectedByParent,
		placeTags,
		places { id, title, timezone, tags },
		customField0
		customField1
		customField2
		customField3
		customField4
		customField5
		customField6
		customField7
		customField8
		customField9
		`;
exports.default = AssetModel;
ModelRegistry_1.default[DataType_1.default.ASSET] = AssetModel;
